import Phaser from 'phaser';
import gameData from '../gameData';
import GameBackground from '../mathLines/GameBackground';
import ABCyaPhaser from '@abcya/abcya_phaser';
import Dino from '../mathLines/Dino';
import SoundAssetKeys from '../SoundAssetKeys';
import FontKeys from '../FontKeys';
import LevelSelectGroup from '../mathLines/LevelSelectGroup';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    console.log('Intro');

    gameData.level = 1;
    gameData.score = 0;
    gameData.addNum = 0;
    this.numSelected = false;

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.introSound = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    this.anims.create({ key: 'char-1-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-1-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-1-happy_', start: 1, end: 7 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-extra', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-extra_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'char-2-happy', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'char-2-happy_', start: 1, end: 6 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-1-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-1-blink_', start: 1, end: 3 }), frameRate: 20 });
    this.anims.create({ key: 'eyes-2-blink', frames: this.anims.generateFrameNames('UIAssets', { prefix: 'eyes-2-blink_', start: 1, end: 3 }), frameRate: 20 });

    this.bg = new GameBackground(this, this.mid.x * 2, this.mid.y * 2);
    this.bg.addBackgroundImage('forest-bg');

    this.char1 = new Dino(this, 1);
    this.char1.x = -this.char1.getBounds().width;
    this.char1.endX = 20 + this.char1.getBounds().width / 2;
    this.char1.y = this.mid.y * 2 - 50;

    this.char2 = new Dino(this, 2);
    this.char2.x = this.mid.x * 2 + this.char2.getBounds().width / 2;
    this.char2.endX = this.mid.x * 2 - this.char2.getBounds().width / 2 - 20;
    this.char2.y = this.mid.y * 2 - this.char2.getBounds().height / 2 - 50;

    this.titleSprite = ABCyaPhaser.Images.addImage(0, 0, 'title', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setAlpha(0);
    this.titleSprite.scaleX = 0;

    this.separator = ABCyaPhaser.Images.addImage(0, 0, 'dash-separator', this).setAlpha(0);
    this.separator.scaleX = 0;

    this.goBtn = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'btnStart', null, () => {
      this.finishIntro();
    }, this, { disabledTint: '0xFFFFFF' }).setEnabled(false)
      .setAlpha(0);

    this.selectTxt = ABCyaPhaser.Text.addText(0, 0, 30, '0xFFFFFF', FontKeys._odin_roundedregular, 'TO BEGIN, CLICK ON A NUMBER\nTHAT YOU WANT THE BALLS TO MULTIPLY TO.', this).setAlpha(0);
    this.selectTxt.scaleX = 0;

    const nums = [12,18,20,24,28,30,32,36,40,42,54,60,72];

    this.selectBtns = new LevelSelectGroup(this, nums);
    this.selectBtns.alpha = 0;
    this.selectBtns.on('BTN_SELECT', (e) => {this.handleBtnSelect(e);});

    this.foregroundLeaves = ABCyaPhaser.Images.addImage(0, 0, 'forest-leaves', this).setScale(2)
      .setAlpha(0);

    this.time.delayedCall(100, () => {this.startIntro();});

    this.layoutRatio();
  }

  startIntro() {
    // animate title
    ABCyaPhaser.Tweens.addTween(this.foregroundLeaves, 3000, { scale: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

    // walk in dinos
    this.time.delayedCall(500, () => {
      this.char1.walkIn(this.char1.endX, 500);
    });
    this.time.delayedCall(1500, () => {
      this.char2.walkIn(this.char2.endX, 500);
    });

    ABCyaPhaser.Tweens.addTween(this.titleSprite, 1500, { delay: 500, scale: 1, alpha: 1 }, Phaser.Math.Easing.Back.Out);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._math_lines_music, this, .5, true);
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._math_lines_multi_title, this.introSound);
    this.introSound.once('complete', () => {this.addButtons();});
  };

  addButtons() {
    this.introSound.destroy();
    this.introSound = null;

    ABCyaPhaser.Tweens.addTween(this.separator, 700, { delay: 200, scaleX: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.selectTxt, 700, { delay: 200, scaleX: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);
    ABCyaPhaser.Tweens.addTween(this.selectBtns, 200, { delay: 200, alpha: 1 }, Phaser.Math.Easing.Quadratic.In, () => {
      this.selectBtns.showButtons();
    });
    ABCyaPhaser.Tweens.addTween(this.goBtn, 500, { delay: 1000, alpha: 1 }, Phaser.Math.Easing.Back.Out, () => {
      this.introReady();
    });
  };

  introReady() {
    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._math_lines_multi_select_instructions, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.goBtn.setEnabled(true);
  };

  handleBtnSelect(e) {
    gameData.addNum = e;
    this.numSelected = true;
  };

  finishIntro() {
    if (this.introSound !== null) {
      this.introSound.destroy();
      this.introSound.stop();
      this.introSound = null;
    }

    if (this.numSelected === true) {
      this.goBtn.setEnabled(false);
      this.selectBtns.hideButtons();

      ABCyaPhaser.Tweens.addTween(this.goBtn, 200, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.selectBtns, 200, { delay: 300, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.titleSprite, 500, { scaleX: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.separator, 500, { scaleX: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);
      ABCyaPhaser.Tweens.addTween(this.selectTxt, 500, { scaleX: 0, alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);

      // walk out dinos
      this.time.delayedCall(300, () => {this.char1.danceAcross(1500);});
      this.time.delayedCall(800, () => {this.char2.danceAcross(500);});
      this.time.delayedCall(1500, () => {this.cleanUp();});
    }
    else {
      ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._cartoon_slide_flip, this);

      ABCyaPhaser.Tweens.addTween(this.selectBtns, 300, { scale: 1.1 }, Phaser.Math.Easing.Quadratic.Out, () => {
        ABCyaPhaser.Tweens.addTween(this.selectBtns, 100, { scale: 1 }, Phaser.Math.Easing.Quadratic.In);
      });
    }
  };

  cleanUp() {
    this.sound.stopAll();
    this.tweens.killAll();

    this.titleSprite = null;
    this.goBtn = null;

    this.scene.start('Instructions');
  };

  update() {
    if (this.char1) this.char1.tick();
    if (this.char1) this.char2.tick();
  };

  layoutRatio() {
    this.char1.y = this.mid.y * 2 - 50;
    this.char2.y = this.mid.y * 2 - this.char2.getBounds().height / 2 - 50;

    this.titleSprite.x = this.mid.x;
    this.titleSprite.y = this.mid.x * 2 === true ? 100 : 210;
    this.separator.x = this.mid.x;
    this.separator.y = this.titleSprite.y + this.titleSprite.getBounds().height - 20;
    this.selectTxt.x = this.mid.x + 10;
    this.selectTxt.y = this.separator.y + 60;
    this.selectBtns.x = this.mid.x;
    const btnOffset = this.mid.x * 2 === true ? 20 : 50;
    this.selectBtns.y = this.selectTxt.y + this.selectTxt.getBounds().height + btnOffset;
    this.foregroundLeaves.x = this.mid.x;
    this.foregroundLeaves.y = this.bg.getBounds().height / 2 + this.bg.bgImage.y - (this.foregroundLeaves.getBounds().height / 2) + 185;

    this.goBtn.x = this.mid.x;
    this.goBtn.y = this.mid.x * 2 === true ? this.mid.y * 2 - (this.goBtn.getBounds().height / 2) - 10 : this.mid.y * 2 - this.goBtn.getBounds().height;
  };
}